import Actor from './actor'
import $ from 'jquery'

/**
 * Sends an alert
 */
class SendAlertActor extends Actor {
	act() {
		const { action } = this.options
		const { alertMessage, alertUserIds, alertGroupIds, alertPopup, formId } = action
		const url = 'api/alerts/form-alert'
		const data = {
			message: alertMessage,
			userIds: alertUserIds,
			groupIds: alertGroupIds,
			popup: alertPopup,
			formId
		}
		let xhr = $.post({
			url,
			data: JSON.stringify(data)
		})
		return xhr
	}
}
export default SendAlertActor
SendAlertActor.__filename__ = 'forms/actions/send-alert-actor.js'
